"use client";

import useFetchApi from "@/hooks/useFetchApi";
import { Dropdown, Menu } from "antd";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const MenuComponent = ({ menuItems, drawer = false }) => {
  const pathname = usePathname();
  const [current, setCurrent] = useState("home");
  const onClick = (e) => {
    setCurrent(e.key);
  };
  const showChildren = (e, isShown) => {
    if (!isShown) {
      setKey("");
      return;
    }
    if (e.children?.length) {
      setKey(e.id);
    }
  };
  return (
    <>
      <div
        className={`flex gap-12 ${drawer ? "flex-col p-2" : "flex-row  items-center"}`}
      >
        {menuItems.map((item, index) => {
          return (
            <Link
              key={item.slug}
              className={`font-semibold text-lg ${
                pathname === item.slug
                  ? "text-[#E5C383]"
                  : `${drawer ? "text-gray-500" : "text-white"}`
              }`}
              href={item.slug}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default MenuComponent;
